import { format, subDays } from 'date-fns'

export interface DateRange {
  // Inclusive ISO `YYYY-MM-DD` bounds, interpreted as local calendar days.
  start: string
  end: string
}

export const toIso = (date: Date) => format(date, 'yyyy-MM-dd')

// Span in days back from today for each quick preset. Every value must stay
// under the audit-log window cap (AUDIT_LOG_MAX_WINDOW_DAYS) so selecting a
// preset can never trip the validation banner — guarded by presets.test.ts.
export const PRESET_DAYS = [7, 30, 90] as const

export const presetRange = (days: number, today: Date): DateRange => ({
  start: toIso(subDays(today, days)),
  end: toIso(today),
})
